module.exports = " <div class=result _v-3a0ed1ac=\"\"> <img :src=imgData @click=previewImg class=save-img data-rlog=result.img _v-3a0ed1ac=\"\"> <img src=" + require("../assets/words.png") + " class=btn _v-3a0ed1ac=\"\"> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-3a0ed1ac!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/resultShare.vue
// module id = 98
// module chunks = 1